@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;
@use 'styles/mixins/fonts' as *;

.optionsItem {
    @include largeFont;

    background-color: $backgroundColor;
    color: $ellipsesDropdownText;
    cursor: pointer;
    display: flex;
    font-weight: 500;
    padding: rem(12px) rem(20px);
    user-select: none;
    white-space: nowrap;
    width: 100%;

    &:not(:first-child) {
        border-top: solid rem(1px) $ellipsesDropdownDivider;
    }

    &:hover,
    &:active {
        background-color: $ellipsesDropdownHover;
        cursor: pointer;
    }
}

.optionItemDelete {
    color: $deleteColor;
}

.disabled {
    background-color: $ellipsesDropdownDisabledBackground;
    color: $ellipsesDropdownDisabledText;

    &:hover,
    &:active {
        background-color: $ellipsesDropdownDisabledBackground;
        cursor: not-allowed;
    }
}
